import {DPlexLoader} from './DPlexLoader';

export class DPlexForm {

    constructor(private form:JQuery<HTMLFormElement>) {
        form.on('submit',(ev)=>this.onsubmit(ev));
    }

    private formToArray(elem:HTMLFormElement) {
        let output:any={};
        new FormData(elem).forEach(
            (value,key)=>{
                var is_array=(key.slice(-2)=='[]');
                if (is_array) {
                    key=key.slice(0,-2);
                    if (!output.hasOwnProperty(key)) output[key]=[];
                    output[key].push(value);
                } else {
                    if (value!=='') output[key]=value;
                }
            }
        );
        return output;
    }

    private onsubmit(ev:JQuery.TriggeredEvent) {
        ev.preventDefault();
        let action=this.form.attr('action');
        if (!action) return;
        let method=this.form.attr('method');
        let data=this.formToArray(this.form[0]);
        if (method && method.toLowerCase()=='post') {
            new DPlexLoader().navigate(action,{post:data});
        } else {
            delete data['form_token'];
            delete data['form_build_id'];
            action+=(action.indexOf('?')==-1)?'?':'&';
            action+=$.param(data).replace(/%5B/g,'[').replace(/%5D/g,']');
            new DPlexLoader().navigate(action);
        }
    }

}

export {};